import { DepartmentModel } from './../storeModels/department.model';
import { Action } from '@ngrx/store';
import * as DepartmentAction from '../actions/department.action';

const userEmptyData = {
    id: '',
    description: '',
    orgID: '',
    status: '',
    name: ''
}
const userDetail = localStorage['departmentInfo'] ? JSON.parse(localStorage['departmentInfo']) : null;
const initialState: DepartmentModel = userDetail || userEmptyData

export function departmentReducer(state: DepartmentModel = initialState, action: DepartmentAction.Actions) {
    switch (action.type) {
        case DepartmentAction.UPDATE_ALL_INFO:
            return {...state,...action.payload};
        default:
            return state;
    }
}
